module.exports = __webpack_public_path__ + "static/media/d4defffa.jpg";